import { styled, useThemeProps } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import Carousel from './Carousel';

const BannerLogo = styled('img', {
  name: 'LoginBanner',
  slot: 'logo',
})({
  position: 'absolute',
  top: '30%',
  maxWidth: '90%',
  maxHeight: '35%',
  height: 'auto',
});

const Banner = styled('div', {
  name: 'LoginBanner',
  slot: 'root',
})({
  color: 'white',
  background: 'linear-gradient(159deg, #F5667A 0%, #FF574D 51%, #F5667A 100%)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'auto',
  borderRadius: '12px',
  height: '100%',
  display: 'flex',
  maxWidth: '684px',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'flex-end',
  position: 'relative',
});

const LoginBanner = forwardRef((inProps, ref) => {
  const props = useThemeProps({ props: inProps, name: 'LoginBanner' });
  const { logoSrc, showCarousel } = props;
  const ownerState = { ...props };

  return (
    <Banner ref={ref} ownerState={ownerState}>
      <BannerLogo src={logoSrc} alt='' />
      {showCarousel ? <Carousel /> : null}
    </Banner>
  );
});

LoginBanner.propTypes = {
  logoSrc: PropTypes.string,
  showCarousel: PropTypes.bool,
};

export default LoginBanner;
